<ham-modal
    [title]="
        view === 'list'
            ? ('aumico_abacus_manage_modal_title' | i18next)
            : view === 'detail'
            ? ((selectedServer$ | async)?.connection?.displayName || ('aumico_abacus_manage_modal_title' | i18next))
            : ('aumico_abacus_manage_disconnect_confirm_title' | i18next)
    "
    [hideFooter]="true"
    [size]="'lg'"
    (cancel)="onClose()"
>
    <div class="manage-modal-body">
        <!-- ─────────── List view ─────────── -->
        <ng-container *ngIf="view === 'list'">
            <ng-container *ngIf="servers$ | async as servers">
                <p *ngIf="servers.length === 0" class="manage-modal-body__empty">
                    {{ 'aumico_abacus_manage_empty' | i18next }}
                </p>

                <ul class="manage-modal-body__tenant-list" *ngIf="servers.length > 0">
                    <li
                        *ngFor="let row of servers; trackBy: trackByConnectionId"
                        class="manage-modal-body__tenant-card"
                        [class.manage-modal-body__tenant-card--warn]="row.needsReAuth"
                        (click)="onSelectServer(row)"
                    >
                        <div class="manage-modal-body__tenant-main">
                            <div class="manage-modal-body__tenant-text">
                                <div class="manage-modal-body__tenant-title">
                                    {{ row.connection.displayName }}
                                </div>
                                <div class="manage-modal-body__tenant-sub">
                                    {{ row.connection.abacus?.serverUrl }}
                                </div>
                                <div
                                    class="manage-modal-body__tenant-status"
                                    [class.manage-modal-body__tenant-status--ok]="!row.needsReAuth"
                                    [class.manage-modal-body__tenant-status--warn]="row.needsReAuth"
                                >
                                    <span class="manage-modal-body__status-dot"></span>
                                    {{
                                        row.needsReAuth
                                            ? ('aumico_abacus_manage_status_reauth' | i18next)
                                            : ('aumico_integration_status_connected' | i18next)
                                    }}
                                </div>
                            </div>
                            <div class="manage-modal-body__tenant-chevron">›</div>
                        </div>
                    </li>
                </ul>

                <button
                    type="button"
                    class="manage-modal-body__add-tenant"
                    (click)="onAddServer()"
                >
                    <span class="manage-modal-body__add-tenant-icon">+</span>
                    {{ 'aumico_abacus_manage_add_server' | i18next }}
                </button>
            </ng-container>
        </ng-container>

        <!-- ─────────── Detail view ─────────── -->
        <ng-container *ngIf="view === 'detail' && selectedServer$ | async as selected">
            <button
                type="button"
                class="manage-modal-body__back"
                (click)="onBackToList()"
            >
                ‹ {{ 'aumico_abacus_manage_back_to_list' | i18next }}
            </button>

            <div class="manage-modal-body__detail-header">
                <div>
                    <div class="manage-modal-body__detail-title">{{ selected.connection.displayName }}</div>
                    <div class="manage-modal-body__detail-sub">
                        {{ selected.connection.abacus?.serverUrl }}
                    </div>
                    <div
                        class="manage-modal-body__tenant-status"
                        [class.manage-modal-body__tenant-status--ok]="!selected.needsReAuth"
                        [class.manage-modal-body__tenant-status--warn]="selected.needsReAuth"
                    >
                        <span class="manage-modal-body__status-dot"></span>
                        {{
                            selected.needsReAuth
                                ? ('aumico_abacus_manage_status_reauth' | i18next)
                                : ('aumico_integration_status_connected' | i18next)
                        }}
                    </div>
                </div>
            </div>

            <hr class="manage-modal-body__divider" />

            <div class="manage-modal-body__companies">
                <div class="manage-modal-body__companies-header">
                    <span class="manage-modal-body__label">
                        {{ 'aumico_abacus_manage_companies_section_title' | i18next }}
                    </span>

                    <div class="manage-modal-body__search">
                        <input
                            type="text"
                            [value]="searchTerm$ | async"
                            (input)="onSearchTermChange($any($event.target).value)"
                            [placeholder]="'aumico_integration_search_company_placeholder' | i18next"
                        />
                    </div>
                </div>

                <ng-container *ngIf="filteredMappedCompanies$ | async as rows">
                    <p *ngIf="rows.length === 0" class="manage-modal-body__empty">
                        {{ 'aumico_abacus_manage_companies_empty' | i18next }}
                    </p>

                    <div *ngIf="rows.length > 0" class="manage-modal-body__companies-scroll">
                        <table class="manage-modal-body__companies-table">
                            <thead>
                                <tr>
                                    <th>{{ 'aumico_integration_aumico_company_label' | i18next }}</th>
                                    <th>{{ 'aumico_abacus_mandanten_id_label' | i18next }}</th>
                                    <th class="manage-modal-body__companies-table-action"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of rows; trackBy: trackByAumicoCompanyId">
                                    <td>{{ row.name }}</td>
                                    <td>{{ row.mapping.externalCompanyId }}</td>
                                    <td class="manage-modal-body__companies-table-action">
                                        <button
                                            type="button"
                                            class="manage-modal-body__row-edit"
                                            (click)="onEditMapping(row)"
                                        >
                                            {{ 'aumico_button_edit' | i18next }}
                                        </button>
                                        <button
                                            type="button"
                                            class="manage-modal-body__row-unlink"
                                            (click)="onUnlink(row)"
                                        >
                                            {{ 'aumico_d365bc_manage_btn_unlink' | i18next }}
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ng-container>

                <button
                    type="button"
                    class="manage-modal-body__add-tenant"
                    (click)="onAddMapping()"
                >
                    <span class="manage-modal-body__add-tenant-icon">+</span>
                    {{ 'aumico_abacus_manage_add_mapping' | i18next }}
                </button>
            </div>

            <div class="manage-modal-body__detail-actions">
                <ham-button
                    variant="red"
                    size="sm"
                    [outline]="true"
                    (buttonClick)="onRequestDisconnect(selected.connection)"
                >
                    {{ 'aumico_abacus_manage_btn_disconnect' | i18next }}
                </ham-button>
            </div>
        </ng-container>

        <!-- ─────────── Disconnect confirm ─────────── -->
        <ng-container *ngIf="view === 'confirm_disconnect' && disconnectCandidate as candidate">
            <div class="manage-modal-body__centered">
                <div class="manage-modal-body__warn-icon">!</div>
                <h3 class="manage-modal-body__heading">
                    {{ 'aumico_abacus_manage_disconnect_confirm_title' | i18next }}
                </h3>
                <p class="manage-modal-body__paragraph">
                    {{ candidate.displayName }}
                </p>
                <p class="manage-modal-body__paragraph manage-modal-body__paragraph--muted">
                    {{ 'aumico_abacus_manage_disconnect_confirm_text' | i18next }}
                </p>

                <div class="manage-modal-body__actions manage-modal-body__actions--centered">
                    <ham-button variant="red" size="sm" (buttonClick)="onConfirmDisconnect()">
                        {{ 'aumico_abacus_manage_btn_disconnect' | i18next }}
                    </ham-button>
                    <ham-button
                        variant="primary"
                        size="sm"
                        [outline]="true"
                        (buttonClick)="onCancelDisconnect()"
                    >
                        {{ 'aumico_button_cancel' | i18next }}
                    </ham-button>
                </div>
            </div>
        </ng-container>
    </div>
</ham-modal>
